import React, { FC, memo } from 'react';

import { toast } from '@shared/ui';
import { DEFAULT_ERROR_MESSAGE } from '@shared/config';
import { useAccountCompanyId } from 'application/hooks';
import { ModalProps, ModalTypes } from 'application/providers/ModalProvider';

import { useRequestCompanyPlaybackEarlyReport } from '@entities/media';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';

import styles from './index.module.scss';
import { TEXTS } from './texts';
import { DATA_TEST_IDS } from './consts';

const FIRST_REFETCH_INTERVAL = 1000;

const RequestPlaybackReportModal: FC<ModalProps[ModalTypes.REPORT_CREATE_PLAYBACK]> = ({
  rightholderId,
  rightholderTitle,
  refetchReports,
  close,
}) => {
  const companyId = useAccountCompanyId();

  const { request, result } = useRequestCompanyPlaybackEarlyReport();

  const onRequestSubmit = async () => {
    try {
      const isOk = await request({ companyId, rightholderId, emailsTo: [] });

      if (!isOk) {
        throw new Error();
      }

      close();

      toast.info(TEXTS.REQUEST_REPORT_SUCCESS_NOTIFICATION);

      setTimeout(() => {
        refetchReports();
      }, FIRST_REFETCH_INTERVAL);
    } catch (error) {
      toast.error(DEFAULT_ERROR_MESSAGE);
    }
  };

  return (
    <ModalScreen
      title={TEXTS.REQUEST_REPORT_MODAL_TITLE}
      onClose={close}
      hideCloseButton
      elementId={DATA_TEST_IDS.MODAL}
      actionButtons={[
        <Button
          elementId="button_submit_request_report_modal"
          key="button_submit_request_report_modal"
          type={ButtonType.PRIMARY}
          onClick={onRequestSubmit}
          isLoading={result.loading}>
          {TEXTS.REQUEST}
        </Button>,
        <Button
          elementId="button_cancel_request_report_modal"
          key="button_cancel_request_report_modal"
          type={ButtonType.SECONDARY}
          onClick={() => close()}>
          {TEXTS.CLOSE}
        </Button>,
      ]}>
      <span
        className={styles.content}
        data-testid={DATA_TEST_IDS.CONTENT}>
        {TEXTS.REQUEST_REPORT_MODAL_CONTENT(rightholderTitle)}
      </span>
    </ModalScreen>
  );
};

export default memo(RequestPlaybackReportModal);
